import { ACCOUNT, ACCOUNTBYPHONE, RESPONSEDATA } from "app/shared/services/services-model.type";
import { DataTransferCreate } from "../../reducer/types";
import {
  FETCH_TRANSFER_CHARITY_CREATE_REQUEST,
  FETCH_TRANSFER_CHARITY_CREATE_SUCCESS,
  FETCH_TRANSFER_CHARITY_CREATE_FAILURE,
  FETCH_TRANSFER_CHARITY_CONFIRM_REQUEST,
  FETCH_TRANSFER_CHARITY_CONFIRM_SUCCESS,
  FETCH_TRANSFER_CHARITY_CONFIRM_FAILURE,
  FETCH_TRANSFER_CHARITY_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_CHARITY_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TRANSFER_CHARITY_AUTHORIZATION_KEY_FAILURE,
  SET_TRANSFER_CHARITY_STORE,
  SET_TRANSFER_CHARITY_RESET,
  FETCH_TRANSFER_CHARITY_ACCOUNT_DETAIL_REQUEST,
  FETCH_TRANSFER_CHARITY_ACCOUNT_DETAIL_SUCCESS,
  FETCH_TRANSFER_CHARITY_ACCOUNT_DETAIL_FAILURE,
  FETCH_TRANSFER_CHARITY_MAKE_FEE_REQUEST,
  FETCH_TRANSFER_CHARITY_MAKE_FEE_SUCCESS,
  FETCH_TRANSFER_CHARITY_MAKE_FEE_FAILURE,
  FETCH_TRANSFER_CHARITY_DETAIL_BY_PHONE_REQUEST,
  FETCH_TRANSFER_CHARITY_DETAIL_BY_PHONE_SUCCESS,
  FETCH_TRANSFER_CHARITY_DETAIL_BY_PHONE_FAILURE,
} from "./actions.type";
import {
  FetchTransferCharityCreateRequest,
  FetchTransferCharityCreateSuccess,
  FetchTransferCharityCreateFailure,
  FetchTransferCharityConfirmRequest,
  FetchTransferCharityConfirmSuccess,
  FetchTransferCharityConfirmFailure,
  FetchTransferCharityAuthorizationRequest,
  FetchTransferCharityAuthorizationSuccess,
  FetchTransferCharityAuthorizationFailure,
  SetTransferCharityStore,
  TransferCharityState,
  SetTransferCharityReset,
  FetchTransferCharityAccountDetailRequest,
  FetchTransferCharityAccountDetailSuccess,
  FetchTransferCharityAccountDetailFailure,
  FetchTransferCharityMakeFeeFailure,
  FetchTransferCharityMakeFeeSuccess,
  FetchTransferCharityMakeFeeRequest,
  FetchTransferCharityDetailByPhoneRequest,
  FetchTransferCharityDetailByPhoneSuccess,
  FetchTransferCharityDetailByPhoneFailure,
} from "./types";

// Charity
export const fetchTransferCharityCreateRequest = (payload: DataTransferCreate): FetchTransferCharityCreateRequest => ({
  type: FETCH_TRANSFER_CHARITY_CREATE_REQUEST,
  payload,
});

export const fetchTransferCharityCreateSuccess = (payload?: RESPONSEDATA): FetchTransferCharityCreateSuccess => ({
  type: FETCH_TRANSFER_CHARITY_CREATE_SUCCESS,
  payload,
});

export const fetchTransferCharityCreateFailure = (payload?: string): FetchTransferCharityCreateFailure => ({
  type: FETCH_TRANSFER_CHARITY_CREATE_FAILURE,
  payload,
});

export const fetchTransferCharityConfirmRequest = (payload?: RESPONSEDATA): FetchTransferCharityConfirmRequest => ({
  type: FETCH_TRANSFER_CHARITY_CONFIRM_REQUEST,
  payload,
});

export const fetchTransferCharityConfirmSuccess = (payload?: RESPONSEDATA): FetchTransferCharityConfirmSuccess => ({
  type: FETCH_TRANSFER_CHARITY_CONFIRM_SUCCESS,
  payload,
});

export const fetchTransferCharityConfirmFailure = (payload?: string): FetchTransferCharityConfirmFailure => ({
  type: FETCH_TRANSFER_CHARITY_CONFIRM_FAILURE,
  payload,
});

export const fetchTransferCharityAuthorizationRequest = (
  payload?: RESPONSEDATA,
  code?: string,
): FetchTransferCharityAuthorizationRequest => ({
  type: FETCH_TRANSFER_CHARITY_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTransferCharityAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTransferCharityAuthorizationSuccess => ({
  type: FETCH_TRANSFER_CHARITY_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTransferCharityAuthorizationFailure = (
  errorOTP?: boolean,
  payload?: string,
): FetchTransferCharityAuthorizationFailure => ({
  type: FETCH_TRANSFER_CHARITY_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

export const setTransferCharityStore = (payload: TransferCharityState): SetTransferCharityStore => ({
  type: SET_TRANSFER_CHARITY_STORE,
  payload,
});

export const setTransferCharityReset = (): SetTransferCharityReset => ({
  type: SET_TRANSFER_CHARITY_RESET,
});

// Transfer Detail Account
export const fetchTransferCharityAccountDetailRequest = (
  payload: ACCOUNT,
  showLoading?: boolean,
): FetchTransferCharityAccountDetailRequest => ({
  type: FETCH_TRANSFER_CHARITY_ACCOUNT_DETAIL_REQUEST,
  payload,
  showLoading,
});

export const fetchTransferCharityAccountDetailSuccess = (payload?: ACCOUNT): FetchTransferCharityAccountDetailSuccess => ({
  type: FETCH_TRANSFER_CHARITY_ACCOUNT_DETAIL_SUCCESS,
  payload,
});

export const fetchTransferCharityAccountDetailFailure = (payload?: string): FetchTransferCharityAccountDetailFailure => ({
  type: FETCH_TRANSFER_CHARITY_ACCOUNT_DETAIL_FAILURE,
  payload,
});

export const fetchTransferCharityDetailByPhoneRequest = (payload: string): FetchTransferCharityDetailByPhoneRequest => ({
  type: FETCH_TRANSFER_CHARITY_DETAIL_BY_PHONE_REQUEST,
  payload,
});

export const fetchTransferCharityDetailByPhoneSuccess = (payload?: ACCOUNTBYPHONE): FetchTransferCharityDetailByPhoneSuccess => ({
  type: FETCH_TRANSFER_CHARITY_DETAIL_BY_PHONE_SUCCESS,
  payload,
});

export const fetchTransferCharityDetailByPhoneFailure = (payload?: string): FetchTransferCharityDetailByPhoneFailure => ({
  type: FETCH_TRANSFER_CHARITY_DETAIL_BY_PHONE_FAILURE,
  payload,
});

// Tính phí
export const fetchTransferCharityMakeFeeRequest = (payload: DataTransferCreate): FetchTransferCharityMakeFeeRequest => ({
  type: FETCH_TRANSFER_CHARITY_MAKE_FEE_REQUEST,
  payload,
});

export const fetchTransferCharityMakeFeeFailure = (payload?: string): FetchTransferCharityMakeFeeFailure => ({
  type: FETCH_TRANSFER_CHARITY_MAKE_FEE_FAILURE,
  payload,
});

export const fetchTransferCharityMakeFeeSuccess = (payload?: RESPONSEDATA): FetchTransferCharityMakeFeeSuccess => ({
  type: FETCH_TRANSFER_CHARITY_MAKE_FEE_SUCCESS,
  payload,
});
